import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Descriptions,
  Drawer,
  Dropdown,
  Form,
  Input,
  InputNumber,
  Menu,
  message,
  Modal,
  notification,
  Popconfirm,
  Popover,
  Row,
  Select,
  Table,
  Tag,
  Tooltip,
  Upload,
} from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  DeleteOutlined,
  DownloadOutlined,
  DownOutlined,
  EditOutlined,
  EyeOutlined,
  FileTextOutlined,
  SendOutlined,
  FilterOutlined,
  PhoneOutlined,
  PlusOutlined,
  PrinterOutlined,
  SearchOutlined,
  SyncOutlined,
  UploadOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import EllipsisDropdown from "components/shared-components/EllipsisDropdown";
import Flex from "components/shared-components/Flex";
import utils from "utils";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { APP_PREFIX_PATH } from "../../../../configs/AppConfig";
import { useAuth } from "../../../../data/hooks/firebase/useAuth";
import Text from "antd/lib/typography/Text";
import Loading from "../../../../components/shared-components/Loading";
import _, { cloneDeep } from "lodash";
import { formatPhoneNumber, formatPrice, getPaymentStatus } from "../../../../functions/formatters";
import { CURRENCY } from "../../../../constants/DeliveryConstants";
import PreviewExcelOrdersModal from "./modals/PreviewExcelOrdersModal";
import ImportEdifactOrderModal from "./modals/ImportEdifactOrderModal";
import GenerateDesadvModal from "./modals/GenerateDesadvModal";
import SendDesadvModal from "./modals/SendDesadvModal";
import { parseEdifactOrder, viewDesadv } from "../../../../functions/edifact";
import { useOrderHistory } from "../../edilog/EdiLogDrawer";
import { lastEdiEventAt } from "../../edilog/constants";
import { dummyRequest, isMobile } from "../../../../functions/browser";
import { CHEFS_FARM, GROWY, COMPANY_CONSTANTS, COMPANY_COUNTRY_CODE } from "../../../../constants/CompanyConstants";
import { DATE_FORMAT_DD_MM_YYYY } from "../../../../constants/DateConstant";
import { getFilteredOrders, getFilteredOrdersDeliveryDate } from "../../../../functions/filters";
import { getExcelExportData, parseExcelOrders } from "../../../../functions/excel";
import { FIRESTORE_ORDERS_TABLE, FIRESTORE_REGIONS_TABLE } from "../../../../constants/FirestoreConstant";
import { arrayRemove, deleteDoc, deleteField, doc, getDoc, updateDoc } from "firebase/firestore";
import { firestore } from "../../../../configs/FirebaseConfig";
import locale from "antd/es/date-picker/locale/nl_NL";
import {
  ADDITIONAL_DELIVERY_LABEL,
  DEFAULT_DELIVERY_LABEL_FALLBACK,
  DELIVERY_LABELS,
  FRESHING_BOX_DELIVERY_LABELS,
  ORDER_STATUS_ACCEPTED,
  ORDER_STATUS_CANCELED,
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_CONFIRMED,
  ORDER_STATUS_CREATED,
  ORDER_STATUS_DELIVERED,
  ORDER_STATUS_IN_PROGRESS,
  ORDER_STATUS_NEW,
  ORDER_STATUS_PACKED,
  SOO_COOL_DELIVERY_LABELS,
} from "../../../../constants/OrderConstant";
import { getFirebaseIDToken } from "../../../../functions/firebase/firebase";
import styled from "styled-components";
import { readOrdersExcel, shippingLabelsCombinedApi, sooCoolOrder, stockApiUrl } from "../../../../urls";
import { StyledSelect } from "../../../../styles/sharedStyles";
import axios from "axios";
import { useReactToPrint } from "react-to-print";
import SooCoolPickList from "../../../../components/shared-components/Table/SooCoolPickList";
import {
  generateCratesOverview,
  generateMultiplePackingSlips,
  generateMultiplePicklists,
  generatePackingSlip,
  generatePicklist,
  processOrdersForPrinting,
} from "../../../../functions/print";
import AddOrderModal from "./modals/AddOrderModal";
import EditOrderModal from "./modals/EditOrderModal";
import UnpackOrderModal from "./modals/UnpackOrderModal";
import ExcelExport from "../../../../components/shared-components/ExcelExport";
import dayjs from "dayjs";
import { useOrders } from "../../../../data/hooks/firestore/useOrders";
import { useCustomers } from "../../../../data/hooks/firestore/useCustomers";
import { useProducts } from "../../../../data/hooks/firestore/useProducts";
import { useWebshopUsers } from "../../../../data/hooks/firestore/useWebshopUsers";
import { handleOrderPackingStatusChange } from "../../../../functions/orders";
import roles from "../../../../roles";
import { JIMMY_LOVES_FOOD_ID } from "../../../../constants/PricingConstants";
import { usePriceLists } from "../../../../data/hooks/firestore/usePriceLists";
import { useCountries } from "../../../../data/hooks/firestore/useCountries";
import { useCrateStocks } from "../../../../data/hooks/firestore/useCrateStocks";
import { getBundlePackagingPrice, recalculateBundleItemPricesForOverride } from "../../../../functions/pricing";
import { updatePackagingStockDelta } from "../../../../functions/packagingStock";
import useIsMobile from "../../../../hooks/useIsMobile";
import { sendOrderToFreshingBox } from "../../../../functions/api/freshingbox";

const { RangePicker } = DatePicker;
const { Dragger } = Upload;

const Orders = ({ companyFilter = "All", title = "Orders" }) => {
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const { user: auth, profile, email } = useAuth();
  const [maxDaysAgo, setMaxDaysAgo] = useState(14);
  const [customDateRange, setCustomDateRange] = useState(null);

  // Calculate date range for orders: 14 days back, 30 days forward
  const orderDateRange = customDateRange || [
    dayjs().subtract(maxDaysAgo, "days").format("YYYY-MM-DD"),
    dayjs().add(30, "days").format("YYYY-MM-DD"),
  ];

  const { data: orders, loading: ordersLoading, error: ordersError } = useOrders(null, orderDateRange);
  const { webshopUsers: users, isLoading: webshopUsersLoading } = useWebshopUsers();
  const { customers, isLoading: customersLoading } = useCustomers();
  const { products, isLoading: productsLoading } = useProducts();
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [visible, setVisible] = useState(false);
  const [order, setOrder] = useState(null);
  const ediHistory = useOrderHistory(order?.edifactOrderNumber);
  const [orderUser, setOrderUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isEditingReference, setIsEditingReference] = useState(false);
  const [referenceValue, setReferenceValue] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [datePickerForm] = Form.useForm();
  const [dateRange, setDateRange] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [list, setList] = useState(orders);
  const pickListRef = useRef();
  const [isPrinting, setIsPrinting] = useState(false);
  const [pickListOrders, setPickListOrders] = useState(null);
  const [addOrderModalVisible, setAddOrderModalVisible] = useState(false);
  const [dateSelectionModalVisible, setDateSelectionModalVisible] = useState(false);
  const [selectedDeliveryDate, setSelectedDeliveryDate] = useState(null);
  const [editOrderModalVisible, setEditOrderModalVisible] = useState(false);
  const [isDraggingExcelFile, setIsDraggingExcelFile] = useState(false);
  const [packingLoadingOrders, setPackingLoadingOrders] = useState(new Set());
  const [sooCoolLoadingOrders, setSooCoolLoadingOrders] = useState(new Set());
  const [freshingBoxLoadingOrders, setFreshingBoxLoadingOrders] = useState(new Set());
  const { priceLists } = usePriceLists();
  const { getCountriesMap, getCountryDelivery } = useCountries();
  const [isFetchingShippingLabels, setIsFetchingShippingLabels] = useState(false);

  // Preview Excel Orders Modal state
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewOrders, setPreviewOrders] = useState([]);
  const [previewSkippedOrders, setPreviewSkippedOrders] = useState([]);

  // Import EDIFACT Order Modal state
  const [importEdifactModalVisible, setImportEdifactModalVisible] = useState(false);

  // Generate DESADV Modal state
  const [generateDesadvOrder, setGenerateDesadvOrder] = useState(null);
  const [sendDesadvOrder, setSendDesadvOrder] = useState(null);

  // Table filters state
  const [tableFilters, setTableFilters] = useState({});
  const [filterPopoverVisible, setFilterPopoverVisible] = useState(false);
  const [countryFilter, setCountryFilter] = useState("All");
  const isMobileView = useIsMobile();

  // Price editing state
  const [editingPrices, setEditingPrices] = useState({}); // { productId: newPrice }
  const [editingShippingCost, setEditingShippingCost] = useState(null);
  const [editingDeliveryTimeCharge, setEditingDeliveryTimeCharge] = useState(null);
  const [isSavingPrices, setIsSavingPrices] = useState(false);
  const [editingPriceField, setEditingPriceField] = useState(null); // Which field is being edited
  const [editingShippingField, setEditingShippingField] = useState(false);
  const [editingDeliveryTimeField, setEditingDeliveryTimeField] = useState(false);

  // Crate restocking modal state (used for cancel order with pickedCratesInfo)
  const [unpackModalVisible, setUnpackModalVisible] = useState(false);

  const { crateStocks } = useCrateStocks();
  const { countries } = useCountries();

  useEffect(() => {
    setTableFilters({});
    setCountryFilter("All");
  }, [companyFilter]);

  useEffect(() => {
    if (ordersError) {
      console.error("Error loading orders:", ordersError);
      message.error(t("notifications.error_loading_orders"));
      setIsLoading(false);
      return;
    }

    if (orders) {
      setIsLoading(false);

      // Filter out acquisition orders (type === "acquisition")
      let nonAcquisitionOrders = orders.filter((order) => order.type !== "acquisition");

      // Filter orders by company
      let filteredByCompany = nonAcquisitionOrders;
      if (companyFilter !== "All") {
        filteredByCompany = nonAcquisitionOrders.filter((order) => {
          const customer = customers?.find((c) => c.id === order.farmorderCustomerId);
          return customer?.company === companyFilter;
        });
      }

      // Apply date filter if present
      let dateFiltered = filteredByCompany;
      if (dateRange && dateRange.length > 0) {
        dateFiltered = utils.filterOrdersDateRange(filteredByCompany, dateRange);
      }

      // Apply country filter if present
      let countryFiltered = dateFiltered;
      if (countryFilter !== "All") {
        countryFiltered = dateFiltered.filter((order) => {
          const customer = customers?.find((c) => c.id === order.farmorderCustomerId);
          return customer?.country === countryFilter;
        });
      }

      // Apply search filter if present
      let finalFiltered = countryFiltered;
      if (searchText) {
        finalFiltered = utils.wildCardSearchOnOrder(countryFiltered, searchText);
      }

      setFilteredOrders(finalFiltered);
    }
  }, [orders, ordersError, companyFilter, customers, dateRange, searchText, countryFilter]);

  useEffect(() => {
    // Clear selections when company filter changes
    setSelectedRows([]);
    setSelectedRowKeys([]);
  }, [companyFilter]);

  // For initial date selection
  const handleDateSelection = (date) => {
    setSelectedDeliveryDate(date);
    setDateSelectionModalVisible(false);
    setAddOrderModalVisible(true);
  };

  const handlePickListPrint = useReactToPrint({
    contentRef: pickListRef,
    onAfterPrint: () => {
      setIsPrinting(false);
      setPickListOrders(null);
    },
  });

  const fetchAndOpenShippingLabelsPdf = async ({ orderIds, download = false }) => {
    if (!orderIds || orderIds.length === 0) {
      message.error(t("notifications.no_orders_selected"));
      return;
    }

    if (isFetchingShippingLabels) {
      return;
    }

    const selectedOrders = (orders || []).filter((o) => orderIds.includes(o.id));
    const addOrders = selectedOrders.filter((o) => o?.deliveryLabel === ADDITIONAL_DELIVERY_LABEL);
    const canceledOrders = selectedOrders.filter(
      (o) => o?.farmorderStatus === ORDER_STATUS_CANCELED || o?.farmorderStatus === ORDER_STATUS_CANCELLED,
    );

    const eligibleOrderIds = selectedOrders
      .filter(
        (o) =>
          o?.deliveryLabel !== ADDITIONAL_DELIVERY_LABEL &&
          o?.farmorderStatus !== ORDER_STATUS_CANCELED &&
          o?.farmorderStatus !== ORDER_STATUS_CANCELLED,
      )
      .map((o) => o.id);

    if (addOrders.length > 0 || canceledOrders.length > 0) {
      if (eligibleOrderIds.length === 0) {
        message.warning(
          "Shipping labels cannot be generated for the selected orders. ADD and canceled orders are not included — please generate shipping labels from the original order.",
        );
        return;
      }

      const skippedParts = [];
      if (addOrders.length > 0) {
        skippedParts.push(`ADD order${addOrders.length === 1 ? "" : "s"}`);
      }
      if (canceledOrders.length > 0) {
        skippedParts.push(`canceled order${canceledOrders.length === 1 ? "" : "s"}`);
      }

      message.warning(
        `Shipping labels cannot be generated for ${skippedParts.join(
          " and ",
        )}. These will be skipped — please use the original order instead.`,
      );
    }

    const loadingKey = "fetching-shipping-labels";

    try {
      setIsFetchingShippingLabels(true);
      message.loading({ content: "Generating documents...", key: loadingKey, duration: 0 });

      const token = await getFirebaseIDToken();

      // Handle regular, SooCool and FreshingBox shipping labels (all combined server-side into a single PDF)
      if (eligibleOrderIds.length === 0) {
        message.error({ content: t("notifications.no_orders_selected"), key: loadingKey });
        setIsFetchingShippingLabels(false);
        return;
      }

      const url = `${shippingLabelsCombinedApi}${download ? "?download=1" : ""}`;

      const response = await axios.post(
        url,
        { orderIds: eligibleOrderIds },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);

      if (download) {
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `shipping-labels-${dayjs().format("DD-MM-YYYY-HH-mm")}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const printWindow = window.open(blobUrl, "_blank");
        if (!printWindow) {
          message.warning(t("notifications.please_allow_pop_ups"));
        }
      }

      // revoke after a short delay to allow the browser to load it
      setTimeout(() => {
        try {
          window.URL.revokeObjectURL(blobUrl);
        } catch (e) {
          // ignore
        }
      }, 10_000);

      message.success({ content: "Shipping labels ready", key: loadingKey, duration: 2 });
    } catch (error) {
      console.error("Error fetching shipping labels PDF:", error);
      const backendMessage = error?.response?.data?.message || error?.response?.data || error?.message;
      message.error({ content: backendMessage || t("notifications.error_generating_documents"), key: loadingKey });
    } finally {
      setIsFetchingShippingLabels(false);
    }
  };

  const handlePeriodChange = (period) => {
    setMaxDaysAgo(period);
    setCustomDateRange(null);
    setSelectedRows([]);
    setSelectedRowKeys([]);
    setDateRange([]);
    datePickerForm.resetFields();
  };

  const handleCustomDateRange = (range) => {
    if (range && range[0] && range[1]) {
      setCustomDateRange([range[0].format("YYYY-MM-DD"), range[1].format("YYYY-MM-DD")]);
      setMaxDaysAgo(null);
    } else {
      setCustomDateRange(null);
      setMaxDaysAgo(14);
    }
    setSelectedRows([]);
    setSelectedRowKeys([]);
  };

  const showDrawer = (row) => {
    const currentUser = _.find(users, (item) => item.userId === row.farmorderUserId);
    if (!!currentUser) setOrderUser(currentUser);
    setVisible(true);
    setOrder(row);
    setReferenceValue(row.reference || "");
    setIsEditingReference(false);
  };

  const generateWhatsAppLink = (phoneNumber) => {
    const formattedNumber = formatPhoneNumber(phoneNumber);
    return `https://wa.me/${formattedNumber}`;
  };

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        message.success(t("copied_to_clipboard"));
      })
      .catch((err) => {
        message.error(t("copied_to_clipboard_error"));
      });
  };

  const closeDrawer = () => {
    setOrderUser(null);
    setVisible(false);
    setEditingPrices({});
    setEditingShippingCost(null);
    setEditingDeliveryTimeCharge(null);
    setEditingPriceField(null);
    setEditingShippingField(false);
    setEditingDeliveryTimeField(false);
    setIsEditingReference(false);
    setReferenceValue("");
    setTimeout(() => {
      setOrder(null);
    }, 400);
  };

  const handleReferenceEdit = () => {
    setIsEditingReference(true);
  };

  const handleReferenceSave = async () => {
    try {
      await updateDoc(doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_ORDERS_TABLE, order.id), {
        reference: referenceValue || null,
        updatedAt: dayjs().unix(),
        updatedBy: email,
      });

      setOrder({ ...order, reference: referenceValue });
      setIsEditingReference(false);
      message.success(t("reference_updated"));
    } catch (error) {
      console.error("Error updating reference:", error);
      message.error(t("error_updating_reference"));
    }
  };

  const handleReferenceCancel = () => {
    setReferenceValue(order.reference || "");
    setIsEditingReference(false);
  };

  // Recalculate order with edited prices
  const recalculatedOrder = useMemo(() => {
    if (
      !order ||
      (Object.keys(editingPrices).length === 0 && editingShippingCost === null && editingDeliveryTimeCharge === null)
    ) {
      return order;
    }

    // Update userShoppingCart with new prices
    const updatedCart = order.userShoppingCart.map((item) => {
      const newPrice = editingPrices[item.productId];
      if (newPrice !== undefined) {
        return {
          ...item,
          productPrice: parseFloat(newPrice).toFixed(2),
          ...(item.isBundle && {
            bundleItems: recalculateBundleItemPricesForOverride(item, newPrice),
          }),
        };
      }
      return item;
    });

    // Recalculate subtotal
    const newSubtotal = updatedCart.reduce((acc, item) => acc + parseFloat(item.productPrice) * item.itemCount, 0);

    // Use new shipping cost or original
    const newShipping =
      editingShippingCost !== null ? parseFloat(editingShippingCost) : parseFloat(order.shippingCost || 0);

    // Use new delivery time charge or original
    const newDeliveryTimeCharge =
      editingDeliveryTimeCharge !== null
        ? parseFloat(editingDeliveryTimeCharge)
        : parseFloat(order.deliveryTimeCharge || 0);

    // Recalculate total
    const newTotal = newSubtotal + newShipping + newDeliveryTimeCharge - (order.discountCodeAmount || 0);

    return {
      ...order,
      userShoppingCart: updatedCart,
      subTotalAmount: newSubtotal,
      shippingCost: newShipping,
      deliveryTimeCharge: newDeliveryTimeCharge,
      totalAmount: newTotal,
    };
  }, [order, editingPrices, editingShippingCost, editingDeliveryTimeCharge]);

  const hasUnsavedPriceChanges =
    Object.keys(editingPrices).length > 0 || editingShippingCost !== null || editingDeliveryTimeCharge !== null;

  const handleSavePriceChanges = async () => {
    if (!order || !hasUnsavedPriceChanges) return;

    try {
      setIsSavingPrices(true);

      await updateDoc(doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_ORDERS_TABLE, order.id), {
        userShoppingCart: recalculatedOrder.userShoppingCart,
        subTotalAmount: recalculatedOrder.subTotalAmount,
        shippingCost: parseFloat(recalculatedOrder.shippingCost).toFixed(2),
        deliveryTimeCharge: parseFloat(recalculatedOrder.deliveryTimeCharge).toFixed(2),
        totalAmount: recalculatedOrder.totalAmount,
        updatedAt: dayjs().unix(),
        updatedBy: email,
      });

      message.success(t("notifications.prices_updated_successfully"));

      // Update local order state with new values
      setOrder({
        ...order,
        userShoppingCart: recalculatedOrder.userShoppingCart,
        subTotalAmount: recalculatedOrder.subTotalAmount,
        shippingCost: parseFloat(recalculatedOrder.shippingCost).toFixed(2),
        deliveryTimeCharge: parseFloat(recalculatedOrder.deliveryTimeCharge).toFixed(2),
        totalAmount: recalculatedOrder.totalAmount,
        updatedAt: dayjs().unix(),
        updatedBy: email,
      });

      setEditingPrices({});
      setEditingShippingCost(null);
      setEditingDeliveryTimeCharge(null);
      setEditingPriceField(null);
      setEditingShippingField(false);
      setEditingDeliveryTimeField(false);
    } catch (error) {
      console.error("Error updating prices:", error);
      message.error(t("notifications.error_updating_prices"));
    } finally {
      setIsSavingPrices(false);
    }
  };

  const handleCancelPriceChanges = () => {
    setEditingPrices({});
    setEditingShippingCost(null);
    setEditingDeliveryTimeCharge(null);
    setEditingPriceField(null);
    setEditingShippingField(false);
    setEditingDeliveryTimeField(false);
  };

  const cancelOrderInSooCool = async (sooCoolId, orderId) => {
    if (!sooCoolId) return;
    try {
      const token = await getFirebaseIDToken();
      await axios.delete(sooCoolOrder + `/${sooCoolId}`, { headers: { Authorization: token } }).catch((err) => {
        throw new Error(err.response.data.message);
      });

      // Store old SooCool ID and clear current ID in Firestore
      await updateDoc(doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_ORDERS_TABLE, orderId), {
        oldSooCoolId: sooCoolId,
        sooCoolId: null,
        updatedAt: dayjs().unix(),
        updatedBy: email,
      });

      message.success(t("notifications.order_cancelled_soo_cool"));
    } catch (error) {
      console.error("Error canceling order:", error);
      message.error(t("notifications.error_canceling_order_soo_cool"));
    }
  };

  // State for tracking which order is being canceled (for crate restocking modal)
  const [cancellingOrder, setCancellingOrder] = useState(null);

  // Execute the actual cancel logic after crate restocking (if needed)
  const executeCancelOrder = async (row) => {
    try {
      // Skip additional order logic for JLF orders
      if (row.farmorderCustomerId !== JIMMY_LOVES_FOOD_ID) {
        // Check if this is a main order with additional orders
        const isMainOrder =
          row.additionalOrderIds && Array.isArray(row.additionalOrderIds) && row.additionalOrderIds.length > 0;

        if (isMainOrder) {
          // Get all additional orders, sorted by orderDateTime
          const additionalOrders = orders
            .filter((o) => row.additionalOrderIds.includes(o.id))
            .sort((a, b) => a.orderDateTime - b.orderDateTime);

          if (additionalOrders.length > 0) {
            // First additional order becomes new main order
            const newMainOrder = additionalOrders[0];
            const remainingAdditional = additionalOrders.slice(1);

            // Get customer for default deliveryLabel
            const customer = customers.find((c) => c.id === newMainOrder.farmorderCustomerId);
            const defaultDeliveryLabel = customer?.deliveryLabel || DEFAULT_DELIVERY_LABEL_FALLBACK;

            // Update new main order - remove mainOrderId, set deliveryLabel, add additionalOrderIds
            await updateDoc(
              doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_ORDERS_TABLE, newMainOrder.id),
              {
                mainOrderId: deleteField(),
                deliveryLabel: defaultDeliveryLabel,
                additionalOrderIds: remainingAdditional.map((o) => o.id),
                updatedAt: dayjs().unix(),
                updatedBy: email,
              },
            );

            // Update remaining additional orders to point to new main order
            for (const order of remainingAdditional) {
              await updateDoc(
                doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_ORDERS_TABLE, order.id),
                { mainOrderId: newMainOrder.id, updatedAt: dayjs().unix(), updatedBy: email },
              );
            }
          }
        }

        // Check if this is an additional order
        const isAdditionalOrder = !!row.mainOrderId;

        if (isAdditionalOrder) {
          // Remove this order from the main order's additionalOrderIds
          await updateDoc(
            doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_ORDERS_TABLE, row.mainOrderId),
            {
              additionalOrderIds: arrayRemove(row.id),
              updatedAt: dayjs().unix(),
              updatedBy: email,
            },
          );
        }
      }

      // If there's a SooCool ID, cancel the order in SooCool first
      if (row.sooCoolId) {
        await cancelOrderInSooCool(row.sooCoolId, row.id);
      }

      // Revert packaging stock if order was packed and has scannedCrates
      if (row.scannedCrates && row.scannedCrates.length > 0) {
        try {
          const stockResult = await updatePackagingStockDelta(
            row.scannedCrates, // old (what was used)
            [], // new (nothing, revert all)
            email, // updatedBy
          );
          if (!stockResult.success) {
            console.error("Failed to revert packaging stock:", stockResult.error);
            // Continue anyway - don't block the cancellation
          }
        } catch (error) {
          console.error("Error reverting packaging stock:", error);
          // Continue anyway - don't block the cancellation
        }
      }

      // Delete orderPicking document if it exists (similar to discardOrderPickingProgress)
      try {
        const pickingRef = doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, "orderPickings", row.id);
        const pickingSnap = await getDoc(pickingRef);
        if (pickingSnap.exists()) {
          await deleteDoc(pickingRef);
        }
      } catch (error) {
        console.error("Error deleting orderPicking document:", error);
        // Continue anyway - don't block the cancellation
      }

      // Update the order status to 'canceled' in Firestore
      await updateDoc(doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_ORDERS_TABLE, row.id), {
        farmorderStatus: ORDER_STATUS_CANCELED,
        updatedAt: dayjs().unix(),
        updatedBy: email,
      });

      // Fetch the updated order to send to the stock API
      const updatedOrderRef = await getDoc(
        doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_ORDERS_TABLE, row.id),
      );

      const updatedOrder = updatedOrderRef.data();

      // Update stock via API with the canceled order
      const token = await getFirebaseIDToken();
      await axios.put(stockApiUrl, updatedOrder, {
        headers: { Authorization: token },
      });

      message.success(t("notifications.order_canceled"));
    } catch (error) {
      console.error("Error canceling order:", error);
      message.error(t("notifications.error_canceling_order"));
    }
  };

  const cancelOrder = async (row) => {
    // If order has pickedCratesInfo, show the restocking modal first
    // This handles the crate stock restocking before canceling the order
    if (row.pickedCratesInfo && Object.keys(row.pickedCratesInfo).length > 0) {
      setCancellingOrder(row);
      setUnpackModalVisible(true);
      return;
    }

    // No crate stock to restock, proceed with cancel directly
    await executeCancelOrder(row);
  };

  // Unpack & Discard - directly cancel order and discard all stock (skip mode)
  const handleUnpackAndDiscard = async (row) => {
    try {
      // First, unpack the order if it's packed
      if (row.packed) {
        await handlePackedStatusChange(row.id, false);
      }

      // Then execute cancel without showing modal (discard stock)
      // This is equivalent to selecting "skip" mode in the UnpackOrderModal
      await executeCancelOrder(row);
    } catch (error) {
      console.error("Error unpacking and discarding order:", error);
      message.error(t("notifications.error_unpacking_order"));
    }
  };

  const handleCancelOrder = (order) => {
    if (order.farmorderStatus !== ORDER_STATUS_CANCELED) {
      cancelOrder(order);
    } else {
      message.info(t("notifications.order_already_canceled"));
    }
  };

  const handleDeleteDesadv = async (order) => {
    try {
      await updateDoc(doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_ORDERS_TABLE, order.id), {
        edifactDesadvMessage: deleteField(),
        edifactDesadvSummary: deleteField(),
        edifactDesadvGeneratedAt: deleteField(),
        edifactDesadvSentAt: deleteField(),
        edifactDesadvTid: deleteField(),
      });
      message.success(t("notifications.desadv_deleted"));
    } catch (error) {
      console.error("Error deleting DESADV:", error);
      message.error(t("notifications.error_deleting_desadv"));
    }
  };

  const handlePackedStatusChange = async (orderId, packed) => {
    try {
      const order = orders.find((o) => o.id === orderId);
      if (!order) {
        message.error(t("notifications.order_not_found"));
        return;
      }

      // Add order to loading set
      setPackingLoadingOrders((prev) => new Set(prev).add(orderId));

      // Check if picking document exists with inline Firestore check
      let hasPickingDocument = false;
      try {
        const pickingDocRef = doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, "orderPickings", orderId);
        const pickingDocSnap = await getDoc(pickingDocRef);
        hasPickingDocument = pickingDocSnap.exists();
      } catch (error) {
        console.error("Error checking picking document:", error);
      }

      const result = await handleOrderPackingStatusChange(order, packed, {
        updatedBy: email,
        scannedCrates: order.scannedCrates || [],
        hasPickingDocument,
      });
      if (!result.success) {
        notification.error({
          message: t(
            `notifications.${
              result.error.includes("invoice") ? "cannot_unpack_completed_invoice" : "error_updating_packed_status"
            }`,
          ),
          description: result.error || "Unknown error",
          duration: 0,
        });
        // Remove order from loading set before returning
        setPackingLoadingOrders((prev) => {
          const newSet = new Set(prev);
          newSet.delete(orderId);
          return newSet;
        });
        return;
      }

      // Update the packed status (and invoiceId) in Firestore
      await updateDoc(
        doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_ORDERS_TABLE, orderId),
        result.updateObject,
      );

      // Notify after Firestore update
      if (packed) {
        message.success(t("notifications.order_packed_invoice_created"));
      } else {
        message.success(t("notifications.order_unpacked_invoice_deleted"));
      }

      // Force table to re-sort by updating local state
      setFilteredOrders((prev) =>
        prev
          .map((o) =>
            o.id === orderId
              ? {
                  ...o,
                  packed,
                  invoiceId: packed ? result.invoiceId : null,
                  farmorderStatus: packed ? ORDER_STATUS_PACKED : ORDER_STATUS_CREATED,
                  farmorderId: result.updateObject.farmorderId || o.farmorderId,
                }
              : o,
          )
          .sort((a, b) => {
            const aPacked = a.packed || false;
            const bPacked = b.packed || false;
            return aPacked === bPacked ? 0 : aPacked ? 1 : -1;
          }),
      );
    } catch (error) {
      console.error("Error updating packed status:", error);
      notification.error({
        message: t("notifications.error_updating_packed_status"),
        description: error?.message || error?.toString() || "Unknown error",
        duration: 0,
      });
    } finally {
      // Remove order from loading set
      setPackingLoadingOrders((prev) => {
        const newSet = new Set(prev);
        newSet.delete(orderId);
        return newSet;
      });
    }
  };

  const dropdownMenu = (row) => (
    <Menu>
      <Menu.Item>
        <a onClick={() => showDrawer(row)}>
          <Flex alignItems="center">
            <EyeOutlined />
            <span style={{ marginLeft: 4 }}>{t("details")}</span>
          </Flex>
        </a>
      </Menu.Item>
      <Menu.Item disabled={row.packed}>
        <a onClick={() => openEditOrderModal(row)}>
          <Flex alignItems="center">
            <EditOutlined />
            <span style={{ marginLeft: 4 }}>{t("edit")}</span>
          </Flex>
        </a>
      </Menu.Item>
      <Menu.Item>
        <a onClick={() => openDuplicateModal(row)}>
          <Flex alignItems="center">
            <CopyOutlined />
            <span style={{ marginLeft: 4 }}>{t("duplicate")}</span>
          </Flex>
        </a>
      </Menu.Item>
      {row.edifactOrderNumber && !row.edifactDesadvMessage && (
        <Menu.Item>
          <a onClick={() => setGenerateDesadvOrder(row)}>
            <Flex alignItems="center">
              <FileTextOutlined />
              <span style={{ marginLeft: 4 }}>{t("generate_desadv")}</span>
            </Flex>
          </a>
        </Menu.Item>
      )}
      {row.edifactDesadvMessage && (
        <Menu.Item>
          <a onClick={() => viewDesadv(row)}>
            <Flex alignItems="center">
              <EyeOutlined />
              <span style={{ marginLeft: 4 }}>{t("view_desadv")}</span>
            </Flex>
          </a>
        </Menu.Item>
      )}
      {row.edifactDesadvMessage && (
        <Menu.Item>
          <a onClick={() => setSendDesadvOrder(row)}>
            <Flex alignItems="center">
              <SendOutlined />
              <span style={{ marginLeft: 4 }}>{t(row.edifactDesadvSentAt ? "send_desadv_again" : "send_desadv")}</span>
            </Flex>
          </a>
        </Menu.Item>
      )}
      {row.edifactDesadvMessage && (
        <Menu.Item>
          <Popconfirm
            placement="bottom"
            title={t("confirm_delete_desadv")}
            onConfirm={() => handleDeleteDesadv(row)}
            okText={t("yes")}
            cancelText={t("no")}
          >
            <a onClick={(e) => e.preventDefault}>
              <Flex alignItems="center">
                <DeleteOutlined />
                <span style={{ marginLeft: 4 }}>{t("delete_desadv")}</span>
              </Flex>
            </a>
          </Popconfirm>
        </Menu.Item>
      )}
      {/*<Menu.Item>*/}
      {/*  <Popconfirm*/}
      {/*    placement="bottom"*/}
      {/*    title={t("confirm_delete_order", { name: row.farmorderId })}*/}
      {/*    onConfirm={() => deleteRow(row)}*/}
      {/*    okText={t("yes")}*/}
      {/*    cancelText={t("no")}*/}
      {/*  >*/}
      {/*    <a onClick={(e) => e.preventDefault}>*/}
      {/*      <DeleteOutlined />*/}
      {/*      {t("delete")}*/}
      {/*    </a>*/}
      {/*  </Popconfirm>*/}
      {/*</Menu.Item>*/}
      <Menu.Item disabled={row.packed}>
        <Popconfirm
          placement="bottom"
          title={t("confirm_delete_order", { name: row.farmorderId })}
          onConfirm={() => handleCancelOrder(row)}
          okText={t("yes")}
          cancelText={t("no")}
        >
          <a onClick={(e) => e.preventDefault}>
            <DeleteOutlined />
            <span style={{ marginLeft: 4 }}>{t("cancel")}</span>
          </a>
        </Popconfirm>
      </Menu.Item>
      <Menu.Item>
        <Popconfirm
          placement="bottom"
          title={t("confirm_unpack_and_discard", { name: row.farmorderId })}
          onConfirm={() => handleUnpackAndDiscard(row)}
          okText={t("yes")}
          cancelText={t("no")}
        >
          <a onClick={(e) => e.preventDefault}>
            <CloseOutlined />
            <span style={{ marginLeft: 4 }}>{t("unpack_and_discard")}</span>
          </a>
        </Popconfirm>
      </Menu.Item>

      {/* LOCALLY TO DELETE ORDERS */}
      {/*{process.env.REACT_APP_ENVIRONMENT !== "production" && (*/}
      {/*  <Menu.Item>*/}
      {/*    <a*/}
      {/*      onClick={(e) => {*/}
      {/*        firestore*/}
      {/*          .collection(FIRESTORE_REGIONS_TABLE)*/}
      {/*          .doc(COMPANY_COUNTRY_CODE)*/}
      {/*          .collection(FIRESTORE_ORDERS_TABLE)*/}
      {/*          .doc(row.id)*/}
      {/*          .delete();*/}
      {/*      }}*/}
      {/*    >*/}
      {/*      <DeleteOutlined />*/}
      {/*      {t("delete")}*/}
      {/*    </a>*/}
      {/*  </Menu.Item>*/}
      {/*)}*/}
    </Menu>
  );

  const downloadMenu = (
    <Menu>
      <Menu.Item key="1">
        <a
          onClick={() => {
            const filteredOrders = getFilteredOrdersDeliveryDate(orders, dateRange, selectedRows);
            if (filteredOrders.length === 0) {
              message.error(t("notifications.no_orders_selected"));
              return;
            }

            if (filteredOrders.length === 1) {
              generatePackingSlip(filteredOrders[0], customers, "download");
            } else {
              generateMultiplePackingSlips(filteredOrders, customers, "download");
            }
          }}
        >
          {t("packing_slips")}
        </a>
      </Menu.Item>
      <Menu.Item key="2">
        <a
          onClick={() => {
            const filteredOrders = getFilteredOrdersDeliveryDate(orders, dateRange, selectedRows);
            if (filteredOrders.length === 0) {
              message.error(t("notifications.no_orders_selected"));
              return;
            }

            if (filteredOrders.length === 1) {
              generatePicklist(filteredOrders[0], customers, "download");
            } else {
              generateMultiplePicklists(filteredOrders, customers, "download");
            }
          }}
        >
          {t("picking_slips")}
        </a>
      </Menu.Item>
      <Menu.Item key="3">
        <ExcelExport
          data={
            selectedRowKeys.length > 0 || (!!dateRange && dateRange.length > 0)
              ? getExcelExportData(getFilteredOrders(orders, dateRange, selectedRows))
              : getExcelExportData([])
          }
          fileName={COMPANY_CONSTANTS.WEBSITE_NAME + " bestellingen " + dayjs().format(DATE_FORMAT_DD_MM_YYYY)}
        >
          {t("orders_export")}
        </ExcelExport>
      </Menu.Item>
      <Menu.Item key="4">
        <a
          onClick={() => {
            const filteredOrders = getFilteredOrdersDeliveryDate(orders, dateRange, selectedRows);
            const orderIds = filteredOrders.map((o) => o.id);
            fetchAndOpenShippingLabelsPdf({ orderIds, download: true });
          }}
        >
          {t("shipping_labels")}
        </a>
      </Menu.Item>
      {/*<Menu.Item key="3">*/}
      {/*  <a onClick={(e) => setOrderAverageModalOpen(true)}>{t("order_average")}</a>*/}
      {/*</Menu.Item>*/}
    </Menu>
  );

  const importMenu = (
    <Menu>
      <Menu.Item key="edifact" onClick={() => setImportEdifactModalVisible(true)}>
        {t("edifact_order")}
      </Menu.Item>
    </Menu>
  );

  const printMenu = (
    <Menu>
      <Menu.Item key="1">
        <a
          onClick={() => {
            const filteredOrders = getFilteredOrdersDeliveryDate(orders, dateRange, selectedRows);
            if (filteredOrders.length === 0) {
              message.error(t("notifications.no_orders_selected"));
              return;
            }

            if (filteredOrders.length === 1) {
              generatePackingSlip(filteredOrders[0], customers, "print");
            } else {
              generateMultiplePackingSlips(filteredOrders, customers, "print");
            }
          }}
        >
          {t("packing_slips")}
        </a>
      </Menu.Item>
      <Menu.Item key="2">
        <a
          onClick={() => {
            const filteredOrders = getFilteredOrdersDeliveryDate(orders, dateRange, selectedRows);
            if (filteredOrders.length === 0) {
              message.error(t("notifications.no_orders_selected"));
              return;
            }

            if (filteredOrders.length === 1) {
              generatePicklist(filteredOrders[0], customers, "print");
            } else {
              generateMultiplePicklists(filteredOrders, customers, "print");
            }
          }}
        >
          {t("picking_slips")}
        </a>
      </Menu.Item>
      <Menu.Item key="3">
        <a
          onClick={() => {
            const filteredOrders = getFilteredOrdersDeliveryDate(orders, dateRange, selectedRows);
            const orderIds = filteredOrders.map((o) => o.id);
            fetchAndOpenShippingLabelsPdf({ orderIds, download: false });
          }}
        >
          {t("shipping_labels")}
        </a>
      </Menu.Item>
      <Menu.Item key="4">
        <a
          onClick={() => {
            const filteredOrders = getFilteredOrdersDeliveryDate(orders, dateRange, selectedRows);

            const { pickListOrders } = processOrdersForPrinting(
              filteredOrders,
              customers,
              products,
              SOO_COOL_DELIVERY_LABELS,
            );

            if (pickListOrders.length === 0) {
              message.error(t("notifications.no_soo_cool_orders_selected"));
              return;
            }

            setIsPrinting(true);
            setPickListOrders(pickListOrders);
            setTimeout(() => {
              handlePickListPrint();
            }, 100);
          }}
        >
          {t("soo_cool_picklist")}
        </a>
      </Menu.Item>
      <Menu.Item key="5">
        <a
          onClick={() => {
            const filteredOrders = getFilteredOrdersDeliveryDate(orders, dateRange, selectedRows);
            const result = generateCratesOverview({
              orders: filteredOrders,
              customers,
              companyFilter,
            });
            if (!result.success) {
              if (result.reason === "no_orders") {
                message.error(t("notifications.no_orders_selected"));
              } else if (result.reason === "popup_blocked") {
                message.warning(t("notifications.please_allow_pop_ups"));
              }
            }
          }}
        >
          Crates overview
        </a>
      </Menu.Item>
    </Menu>
  );

  const getOrderStatusColor = (status) => {
    if (status === ORDER_STATUS_DELIVERED) return "green";
    else if (status === ORDER_STATUS_CREATED) return "yellow";
    else if (status === ORDER_STATUS_CONFIRMED || status === ORDER_STATUS_ACCEPTED || status === ORDER_STATUS_PACKED)
      return "lime";
    else if (status === ORDER_STATUS_NEW) return "orange";
    else if (status === ORDER_STATUS_IN_PROGRESS) return "blue";
    else if (status === ORDER_STATUS_CANCELED || status === ORDER_STATUS_CANCELLED) return "red";
    else return "green";
  };

  const tableColumns = [
    {
      title:
        selectedRowKeys.length > 0 ? (
          <span
            style={{ color: "#880e4f", cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedRowKeys([]);
              setSelectedRows([]);
            }}
            title="Clear selection"
          >
            ({selectedRowKeys.length})
          </span>
        ) : (
          ""
        ),
      render: (_, elm) => (
        <div className="text-right">
          <EllipsisDropdown menu={dropdownMenu(elm)} />
        </div>
      ),
    },
    {
      title: t("order_date"),
      dataIndex: "farmorderDateTime",
      sorter: {
        compare: (a, b) => utils.antdTableSorter(a, b, "farmorderDateTime"),
        multiple: 1,
      },
      render: (_, data) => (
        <button className={"text-button"} onClick={() => showDrawer(data)}>
          <span style={{ minWidth: "120px", display: "block" }}>
            {dayjs(data.farmorderDateTime, "YYYY-MM-DD HH:mm:ss").format("D MMM YYYY HH:mm")}
            {data.alertLog?.some((l) => l.status === "open") && <Badge status="error" style={{ marginLeft: 4 }} />}
          </span>
        </button>
      ),
      defaultSortOrder: "ascend",
    },
    {
      title: t("company"),
      sorter: (a, b) => utils.antdTableSorter(a, b, "farmorderCustomerName"),
      render: (_, data) => (
        <div style={{ display: "flex", gap: 6 }}>
          {!!data.farmorderComments && (
            <Popover
              overlayStyle={{ maxWidth: "42ch" }}
              content={
                <>
                  <p style={{ marginBottom: 0 }}>{data.farmorderComments}</p>
                  {!data.orderCommentsProcessed && (
                    <Button
                      size={"small"}
                      style={{ marginLeft: "auto", marginTop: "1em" }}
                      onClick={() => handleProcessComments(data)}
                    >
                      {t("mark_as_processed")}
                    </Button>
                  )}
                </>
              }
            >
              <Badge status={data.orderCommentsProcessed ? "success" : "warning"} />
            </Popover>
          )}
          {data.farmorderCustomerName}{" "}
          {data.deliveryBy === "Growy"
            ? ""
            : !!data.farmorderUserFirstName
              ? `(${data.farmorderUserFirstName} ${data.farmorderUserLastName})`
              : `(${data.farmorderUserId})`}
        </div>
      ),
    },
    {
      title: t("pickup_delivery_date"),
      dataIndex: "farmorderDeliveryDate",
      render: (data) => (
        <span style={{ minWidth: "110px", display: "block" }}>
          {dayjs(data, "YYYY-MM-DD").format("ddd D MMM YYYY")}
        </span>
      ),
      sorter: (a, b) => utils.antdTableSorter(a, b, "farmorderDeliveryDate"),
    },
    {
      title: t("status"),
      dataIndex: "farmorderStatus",
      render: (data) => (
        <span>
          <Tag color={getOrderStatusColor(data)}>{getPaymentStatus(data)}</Tag>
        </span>
      ),
      sorter: (a, b) => utils.antdTableSorter(a, b, "farmorderStatus"),
    },
    {
      title: t("delivery_label"),
      key: "deliveryLabel",
      filters: DELIVERY_LABELS.map((dl) => ({ text: dl.code, value: dl.code })),
      filteredValue: tableFilters.deliveryLabel || null,
      onFilter: (value, order) => order.deliveryLabel?.startsWith(value),
      render: (_, order) => {
        const customer = customers.find((c) => c.id === order.farmorderCustomerId);
        const customerDeliveryLabel = customer?.deliveryLabel;
        const deliveryLabel = order.deliveryLabel ? order.deliveryLabel : customerDeliveryLabel;

        if (SOO_COOL_DELIVERY_LABELS.includes(deliveryLabel)) {
          if (order.sooCoolId) {
            return (
              <span>
                {order.deliveryLabel} - {order.sooCoolOrderKey || order.sooCoolId}
              </span>
            );
          } else {
            const isLoading = sooCoolLoadingOrders.has(order.id);

            if (isLoading) {
              return (
                <span>
                  {order.deliveryLabel} <SyncOutlined spin />
                </span>
              );
            }

            return (
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          handleSendToSooCool(order, "create");
                        }}
                      >
                        {t("send_to_soo_cool")}
                      </a>
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
              >
                <a onClick={(e) => e.preventDefault}>
                  <span>
                    {order.deliveryLabel} ({t("no")})
                  </span>
                </a>
              </Dropdown>
            );
          }
        } else if (FRESHING_BOX_DELIVERY_LABELS.includes(deliveryLabel)) {
          if (order.freshingBoxTrackingNumber) {
            return <span>{order.deliveryLabel}</span>;
          } else {
            const isLoading = freshingBoxLoadingOrders.has(order.id);

            if (isLoading) {
              return (
                <span>
                  {order.deliveryLabel} <SyncOutlined spin />
                </span>
              );
            }

            return (
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          handleSendToFreshingBox(order);
                        }}
                      >
                        {t("send_to_freshingbox")}
                      </a>
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
              >
                <a onClick={(e) => e.preventDefault}>
                  <span>
                    {order.deliveryLabel} ({t("no")})
                  </span>
                </a>
              </Dropdown>
            );
          }
        } else {
          return <span>{order.deliveryLabel}</span>;
        }
      },
    },
    {
      title: t("total"),
      dataIndex: "totalAmount",
      render: (_, order) => {
        let total = order.totalAmount;
        // Make sure shipping costs are always removed from total if they are disabled
        if (order.shippingCostDisabled) total -= order.shippingCost;
        return <span style={{ minWidth: "65px", display: "block" }}>{CURRENCY + formatPrice(total)}</span>;
      },
    },
    {
      title: t("packed"),
      dataIndex: "packed",
      filters: [
        { text: t("picked_orders"), value: "picked" },
        { text: t("administrative_packed"), value: "administrative" },
      ],
      filteredValue: tableFilters.packed || null,
      onFilter: (value, order) => {
        if (value === "picked") {
          return order.packed && !order.administrativelyPacked;
        }
        if (value === "administrative") {
          return order.packed && order.administrativelyPacked;
        }
        return false;
      },
      sorter: {
        compare: (a, b) => {
          const aPacked = a.packed || false;
          const bPacked = b.packed || false;
          return aPacked === bPacked ? 0 : aPacked ? 1 : -1;
        },
        multiple: 2,
      },
      render: (_, order) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Checkbox
            checked={order.packed || false}
            disabled={
              order.invoiceStatus === "in_exact" ||
              order.farmorderStatus === ORDER_STATUS_CANCELED ||
              packingLoadingOrders.has(order.id)
            }
            onChange={(e) => handlePackedStatusChange(order.id, e.target.checked)}
          />
          {packingLoadingOrders.has(order.id) && <SyncOutlined spin />}
        </div>
      ),
    },
    {
      title: "",
      render: (_, elm) => (
        <div
          className="text-right"
          style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "3px" }}
        >
          <div
            className="ellipsis-dropdown"
            onClick={() => generatePackingSlip(elm, customers, "print")}
            style={{ fontSize: "14px", transform: "rotate(0)", padding: "9px" }}
          >
            <PrinterOutlined />
          </div>
          <EllipsisDropdown menu={dropdownMenu(elm)} />
        </div>
      ),
    },
  ];

  const handleProcessComments = async (order) => {
    try {
      await updateDoc(doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_ORDERS_TABLE, order.id), {
        orderCommentsProcessed: true,
        updatedAt: dayjs().unix(),
        updatedBy: email,
      });
      message.success(t("notifications.order_comments_processed"));
    } catch (err) {
      console.log(err);
      message.error(t("notifications.error_processing_order_comments"));
    }
  };

  const handleSendToSooCool = async (order, type = "create") => {
    setSooCoolLoadingOrders((prev) => new Set(prev).add(order.id));

    try {
      const token = await getFirebaseIDToken();
      if (!token) {
        message.error(t("notifications.error_getting_id_token"));
        return;
      }

      const config = {
        headers: { Authorization: token },
      };

      if (type === "create") {
        const response = await axios.post(sooCoolOrder, order, config);
        message.success(t("notifications.order_saved_to_soo_cool"));
        return response;
      } else if (type === "update") {
        const response = await axios.put(sooCoolOrder + "/" + order.sooCoolId, order, config);
        if (response.data?.skipped && response.data?.reason === "cutoff_time_passed") {
          message.warning(t("notifications.soo_cool_cutoff_time_passed"), 6);
        } else {
          message.success(t("notifications.order_updated_in_soo_cool"));
        }
        return response;
      }
    } catch (error) {
      console.log(error.message);
      message.error(t("notifications.error_update_order_to_soo_cool: ", error.message));
      throw error;
    } finally {
      setSooCoolLoadingOrders((prev) => {
        const newSet = new Set(prev);
        newSet.delete(order.id);
        return newSet;
      });
    }
  };

  const handleSendToFreshingBox = async (order) => {
    // Validate scannedCrates
    if (!order.scannedCrates || order.scannedCrates.length === 0) {
      message.warning(t("notifications.freshingbox_requires_scanned_crates"));
      return;
    }

    setFreshingBoxLoadingOrders((prev) => new Set(prev).add(order.id));

    try {
      const token = await getFirebaseIDToken();
      if (!token) {
        message.error(t("notifications.error_getting_id_token"));
        return;
      }

      const result = await sendOrderToFreshingBox(order, token);

      if (result.success) {
        message.success(t("notifications.order_sent_to_freshingbox"));
      } else {
        message.error(t("notifications.error_sending_to_freshingbox") + ": " + result.error);
      }
    } catch (error) {
      console.error("FreshingBox error:", error);
      message.error(t("notifications.error_sending_to_freshingbox") + ": " + error.message);
    } finally {
      setFreshingBoxLoadingOrders((prev) => {
        const newSet = new Set(prev);
        newSet.delete(order.id);
        return newSet;
      });
    }
  };

  const tableColumnsDetails = [
    {
      title: t("product"),
      dataIndex: "productName",
    },
    {
      title: t("quantity"),
      dataIndex: "itemCount",
      render: (itemCount, record) => {
        const lines = order?.pickedCratesInfo?.[record.productId];
        if (!lines?.length) return <span>{itemCount}</span>;

        const hasSubItems = lines.some((l) => l.subItemProductId);

        const columns = [
          ...(hasSubItems
            ? [
                {
                  title: t("bundle_scanning.sub_item"),
                  dataIndex: "subItemProductId",
                  key: "subItemProductId",
                  render: (subItemProductId) => {
                    if (!subItemProductId) return "-";
                    const product = products?.find((p) => p.productId === subItemProductId);
                    return product?.productName || subItemProductId;
                  },
                },
              ]
            : []),
          {
            title: t("picked_crate_ids"),
            dataIndex: "crateId",
            key: "crateId",
          },
          {
            title: t("crate_stock.qty"),
            dataIndex: "quantity",
            key: "quantity",
          },
          {
            title: t("packed"),
            dataIndex: "packageDateUnix",
            key: "packageDateUnix",
            render: (packageDateUnix) => (packageDateUnix ? dayjs.unix(packageDateUnix).format("DD-MM-YYYY") : "-"),
          },
        ];

        return (
          <Popover
            trigger={["hover", "click"]}
            content={
              <div>
                {hasSubItems && (
                  <Text type="secondary" style={{ display: "block", marginBottom: 8, fontSize: 12 }}>
                    {t("bundle_scanning.picked_via_sub_items")}
                  </Text>
                )}
                <Table
                  dataSource={lines}
                  rowKey={(r) => `${r.crateId}-${r.subItemProductId || "main"}`}
                  pagination={false}
                  size="small"
                  columns={columns}
                />
              </div>
            }
          >
            <span style={{ borderBottom: "1px dashed #999", cursor: "pointer" }}>{itemCount}</span>
          </Popover>
        );
      },
    },
    {
      title: t("price"),
      dataIndex: "productPrice",
      render: (data, record) => {
        const canEdit = profile?.userRole === roles.superAdmin && !order?.packed && !order?.invoiceId;
        const isEditing = editingPriceField === record.productId;
        const hasOverride = editingPrices[record.productId] !== undefined;
        const displayPrice = hasOverride ? editingPrices[record.productId] : data;

        if (!canEdit) {
          return <span>{CURRENCY + formatPrice(data)}</span>;
        }

        if (isEditing) {
          const packagingPrice = record.isBundle ? getBundlePackagingPrice(record) : 0;
          return (
            <InputNumber
              autoFocus
              value={parseFloat(displayPrice)}
              onChange={(value) => {
                if (value !== null) {
                  setEditingPrices((prev) => ({ ...prev, [record.productId]: value }));
                }
              }}
              onBlur={() => {
                setEditingPriceField(null);
                // Validate bundle packaging price
                if (record.isBundle && packagingPrice > 0) {
                  const currentPrice = editingPrices[record.productId];
                  if (currentPrice !== undefined && parseFloat(currentPrice) < packagingPrice) {
                    setEditingPrices((prev) => ({
                      ...prev,
                      [record.productId]: packagingPrice.toFixed(2),
                    }));
                    message.warning(t("bundle_price_below_packaging"));
                  }
                }
              }}
              onPressEnter={() => {
                setEditingPriceField(null);
                // Validate bundle packaging price
                if (record.isBundle && packagingPrice > 0) {
                  const currentPrice = editingPrices[record.productId];
                  if (currentPrice !== undefined && parseFloat(currentPrice) < packagingPrice) {
                    setEditingPrices((prev) => ({
                      ...prev,
                      [record.productId]: packagingPrice.toFixed(2),
                    }));
                    message.warning(t("bundle_price_below_packaging"));
                  }
                }
              }}
              precision={2}
              min={0}
              step={0.01}
              style={{ width: "100px" }}
              prefix="€"
            />
          );
        }

        return (
          <span
            onClick={() => setEditingPriceField(record.productId)}
            style={{ cursor: "pointer", textDecoration: "underline", textDecorationStyle: "dashed" }}
          >
            {CURRENCY + formatPrice(displayPrice)}
          </span>
        );
      },
    },
    {
      title: t("sub_total"),
      render: (_, item) => {
        const price =
          editingPrices[item.productId] !== undefined ? editingPrices[item.productId] : parseFloat(item.productPrice);
        const calculatedSubTotal = price * item.itemCount;
        if (!item || !item.itemCount) {
          return <span>{CURRENCY + 0}</span>;
        }
        return <span>{CURRENCY + formatPrice(calculatedSubTotal)}</span>;
      },
    },
  ];

  const onSearch = (value) => {
    setSearchText(value);
  };

  const rowSelection = {
    onChange: (key, rows) => {
      setSelectedRows(rows);
      setSelectedRowKeys(key);
    },
  };

  const handleDateRange = (dateRange) => {
    setDateRange(dateRange);
    setSelectedRows([]);
    setSelectedRowKeys([]);
  };

  const openAddModal = () => {
    setDateSelectionModalVisible(true);
  };

  const closeAddModal = () => {
    setAddOrderModalVisible(false);
    setSelectedDeliveryDate(null);
    setOrder(null);
  };

  const openEditOrderModal = (order) => {
    setOrder(order);
    setEditOrderModalVisible(true);
  };

  const closeEditOrderModal = () => {
    setEditOrderModalVisible(false);
    setSelectedRows([]);
    setSelectedRowKeys([]);
    setTimeout(() => {
      setOrder(null);
    }, 500);
  };

  const openDuplicateModal = (order) => {
    setOrder(order);
    setSelectedDeliveryDate(null);
    setAddOrderModalVisible(true);
  };

  const handleDropFile = async (files) => {
    setIsDraggingExcelFile(false);
    if (files.length > 1) {
      message.error(t("notifications.one_file_at_a_time"));
      return;
    }

    const file = files[0];
    if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      message.error(t("notifications.upload_excel_file"));
      return;
    }

    const token = await getFirebaseIDToken();
    const json = await axios.post(
      readOrdersExcel,
      { file },
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token,
        },
      },
    );

    const { data } = json;
    if (data.orders?.length > 0) {
      const { finalOrders, skippedOrders } = parseExcelOrders(
        data.orders,
        customers,
        products,
        users,
        profile,
        auth,
        companyFilter,
        priceLists,
        getCountriesMap(),
      );

      // Show preview modal instead of directly importing
      setPreviewOrders(finalOrders);
      setPreviewSkippedOrders(skippedOrders);
      setPreviewModalVisible(true);

      // Show notification about skipped orders if any
      if (skippedOrders.length > 0) {
        message.warning(`${skippedOrders.length} ${t("orders_are_missing_data").toLowerCase()}`);
      }
    }
  };

  const handleEdifactParsed = (edifactResult) => {
    const { finalOrders, skippedOrders } = parseEdifactOrder(
      edifactResult,
      customers,
      products,
      auth,
      companyFilter,
      priceLists,
      getCountriesMap(),
    );

    setImportEdifactModalVisible(false);
    setPreviewOrders(finalOrders);
    setPreviewSkippedOrders(skippedOrders);
    setPreviewModalVisible(true);

    if (skippedOrders.length > 0) {
      message.warning(`${skippedOrders.length} ${t("orders_are_missing_data").toLowerCase()}`);
    }
  };

  const handlePreviewModalSuccess = async () => {
    setPreviewModalVisible(false);
    setPreviewOrders([]);
    setPreviewSkippedOrders([]);

    messageApi.success(t("orders_imported_successfully"));
  };

  const handlePreviewModalCancel = () => {
    setPreviewModalVisible(false);
    setPreviewOrders([]);
    setPreviewSkippedOrders([]);
  };

  const resolveAlertLogEntry = async (logIndex) => {
    const clonedLogs = cloneDeep(order.alertLog);
    clonedLogs[logIndex].status = "resolved";
    clonedLogs[logIndex].resolvedAt = dayjs().unix();

    // Update firestore order
    await updateDoc(doc(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_ORDERS_TABLE, order.id), {
      alertLog: clonedLogs,
      updatedAt: dayjs().unix(),
      updatedBy: email,
    });

    // Update order in state
    setOrder({ ...order, alertLog: clonedLogs });
  };

  if (
    ordersLoading ||
    customersLoading ||
    productsLoading ||
    webshopUsersLoading ||
    !orders ||
    !customers ||
    !products ||
    !users
  ) {
    return (
      <>
        {contextHolder}
        <Loading />
      </>
    );
  }

  return (
    <>
      {contextHolder}
      <Row className={"mb-2"}>
        <Col xs={24} md={16} xl={15} xxl={14}>
          <h1>{t(title)}</h1>
        </Col>
        <Col xs={24}>
          <Card>
            <Row gutter={[16, 8]} style={{ justifyContent: "space-between", marginBottom: ".5rem" }}>
              {!isMobileView ? (
                <div style={{ display: "flex", gap: 12, marginTop: "1rem" }}>
                  <Input
                    placeholder={t("search")}
                    style={{ width: "fit-content", maxHeight: 40 }}
                    prefix={<SearchOutlined />}
                    value={searchText}
                    onChange={(e) => onSearch(e.target.value)}
                    allowClear
                  />
                  <StyledSelect
                    style={{ minWidth: 140 }}
                    $isFiltered={countryFilter !== "All"}
                    onChange={(value) => setCountryFilter(value)}
                    placeholder={t("country")}
                    value={countryFilter}
                  >
                    <Select.Option value="All">{t("all_countries")}</Select.Option>
                    {countries.map((country) => (
                      <Select.Option key={country.countryCode} value={country.countryCode}>
                        {country.countryCode}
                      </Select.Option>
                    ))}
                  </StyledSelect>
                </div>
              ) : (
                <div style={{ marginTop: "1rem" }}>
                  <Popover
                    content={
                      <FilterPopoverContent>
                        <div>
                          <FilterLabel>{t("search")}</FilterLabel>
                          <Input
                            placeholder={t("search")}
                            prefix={<SearchOutlined />}
                            value={searchText}
                            onChange={(e) => onSearch(e.target.value)}
                            allowClear
                            size="large"
                          />
                        </div>
                        <div style={{ marginTop: "1rem" }}>
                          <FilterLabel>{t("filter_on_delivery_date")}</FilterLabel>
                          <Form form={datePickerForm}>
                            <Form.Item name="dateRange" style={{ marginBottom: 0 }}>
                              <RangePicker
                                onChange={(e) => handleDateRange(e)}
                                locale={locale}
                                placeholder={[t("start"), t("end")]}
                                format={"DD-MM-YYYY"}
                                style={{ width: "100%" }}
                                size="large"
                                popupClassName="single-month-range-picker"
                              />
                            </Form.Item>
                          </Form>
                        </div>
                        <div style={{ marginTop: "1rem" }}>
                          <FilterLabel>{t("country")}</FilterLabel>
                          <Select
                            placeholder={t("country")}
                            style={{ width: "100%" }}
                            value={countryFilter}
                            onChange={(value) => setCountryFilter(value)}
                            size="large"
                          >
                            <Select.Option value="All">{t("all_countries")}</Select.Option>
                            {countries.map((country) => (
                              <Select.Option key={country.countryCode} value={country.countryCode}>
                                {country.countryCode}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                        <FilterButtonsContainer>
                          <Button
                            onClick={() => {
                              setSearchText("");
                              datePickerForm.resetFields();
                              handleDateRange(null);
                              setCountryFilter("All");
                              setFilterPopoverVisible(false);
                            }}
                            style={{ flex: 1 }}
                          >
                            {t("reset")}
                          </Button>
                          <Button type="primary" onClick={() => setFilterPopoverVisible(false)} style={{ flex: 1 }}>
                            {t("apply")}
                          </Button>
                        </FilterButtonsContainer>
                      </FilterPopoverContent>
                    }
                    title={t("filters")}
                    trigger="click"
                    open={filterPopoverVisible}
                    onOpenChange={setFilterPopoverVisible}
                    placement="bottomLeft"
                  >
                    <Button
                      icon={<FilterOutlined />}
                      style={{
                        borderColor: searchText || dateRange?.length > 0 || countryFilter !== "All" ? "#FF4B33" : "",
                        color: searchText || dateRange?.length > 0 || countryFilter !== "All" ? "#FF4B33" : "",
                      }}
                    />
                  </Popover>
                </div>
              )}
              <ButtonsWrapper>
                {!isMobile && (
                  <Tooltip title={t("filter_on_delivery_date")}>
                    <Form form={datePickerForm}>
                      <Form.Item name="dateRange" style={{ marginBottom: 0 }}>
                        <RangePicker
                          onChange={(e) => handleDateRange(e)}
                          locale={locale}
                          placeholder={[t("start"), t("end")]}
                          format={"DD-MM-YYYY"}
                          style={{ width: "145px" }}
                        />
                      </Form.Item>
                    </Form>
                  </Tooltip>
                )}
                <Dropdown overlay={downloadMenu}>
                  <Button className="ant-btn-primary">
                    <DownloadOutlined /> {!isMobile && t("download")}
                    <DownOutlined />
                  </Button>
                </Dropdown>
                <Dropdown overlay={printMenu}>
                  <Button className="ant-btn-primary">
                    <PrinterOutlined />
                    {!isMobile && t("print")} <DownOutlined />
                  </Button>
                </Dropdown>
                {companyFilter === GROWY && (
                  <Dropdown overlay={importMenu}>
                    <Button>
                      <UploadOutlined /> {!isMobile && t("import")}
                      <DownOutlined />
                    </Button>
                  </Dropdown>
                )}
                <Button type="primary" onClick={openAddModal}>
                  <PlusOutlined /> {!isMobile && t("create_order")}
                </Button>
              </ButtonsWrapper>
            </Row>
            {isLoading ? (
              <Loading />
            ) : (
              <div
                className="table-responsive"
                onDragEnter={(e) => {
                  e.preventDefault();
                  setIsDraggingExcelFile(true);
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                  setIsDraggingExcelFile(true);
                }}
                onDragLeave={(e) => {
                  e.preventDefault();
                  // Alleen false zetten als we het dragger gebied echt verlaten
                  if (!e.currentTarget.contains(e.relatedTarget)) {
                    setIsDraggingExcelFile(false);
                  }
                }}
              >
                <StyledDragger
                  name={"file"}
                  onDrop={(e) => handleDropFile(e.dataTransfer.files)}
                  openFileDialogOnClick={false}
                  customRequest={dummyRequest}
                  fileList={[]}
                >
                  {isDraggingExcelFile && (
                    <UploadOverlayMessage>
                      <h2>{t("drag_and_drop_file_orders_title")}</h2>
                      <p>{t("drag_and_drop_file_orders_message")}</p>
                    </UploadOverlayMessage>
                  )}
                  <Table
                    showSorterTooltip={false}
                    columns={tableColumns}
                    dataSource={filteredOrders}
                    // Use Firestore doc id when available to avoid duplicate rows during interim updates
                    rowKey={(record) => record.id || record.farmorderId}
                    scroll={{ x: 1300 }}
                    rowSelection={{
                      selectedRowKeys: selectedRowKeys,
                      type: "checkbox",
                      preserveSelectedRowKeys: false,
                      ...rowSelection,
                    }}
                    onRow={(record) => {
                      let backgroundColor = {};
                      if (record.deliveryLabel === "ADD") {
                        backgroundColor = { backgroundColor: "#e6f4ff" };
                      } else if (record.packed) {
                        backgroundColor = { backgroundColor: "#fafafa" };
                      }
                      return { style: backgroundColor };
                    }}
                    onChange={(pagination, filters) => {
                      setTableFilters(filters);
                    }}
                    pagination={{ showSizeChanger: true }}
                  />
                </StyledDragger>
              </div>
            )}
            {!!order && (
              <Drawer
                title={
                  order.farmorderCustomerName +
                  " | " +
                  dayjs(order.farmorderDateTime, "YYYY-MM-DD HH:mm:ss").format("D MMM YYYY HH:mm")
                }
                placement="right"
                onClose={closeDrawer}
                open={visible}
                width={isMobile ? window.innerWidth : 850}
                styles={{ body: { padding: isMobile ? 2 : " 16px 16px 50px 16px" } }}
              >
                <Descriptions
                  bordered
                  title={
                    <div className="flex-row">
                      {t("order.order")}{" "}
                      <Tag color={getOrderStatusColor(order.farmorderStatus)}>
                        {getPaymentStatus(order.farmorderStatus)}
                      </Tag>
                    </div>
                  }
                  size="small"
                  column={1}
                >
                  <Descriptions.Item label={t("id")}>
                    {profile?.userRole === roles.superAdmin ? (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          const win = window.open("", "_blank");
                          win.document.write(`<pre>${JSON.stringify(order, null, 2)}</pre>`);
                          win.document.close();
                        }}
                        style={{ color: "rgba(0, 0, 0, 0.88)", cursor: "default" }}
                      >
                        {order.id}
                      </a>
                    ) : (
                      order.id
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item label={t("order_id")}>{order.farmorderId}</Descriptions.Item>
                  <Descriptions.Item label={t("order_date")}>
                    {dayjs(order.farmorderDateTime, "YYYY-MM-DD HH:mm:ss").format("D MMM YYYY HH:mm")}
                  </Descriptions.Item>
                  {!!order.paymentMethod && (
                    <Descriptions.Item label={t("payment_method")}>{order.paymentMethod}</Descriptions.Item>
                  )}
                  <Descriptions.Item
                    label={(() => {
                      const orderCustomer = customers.find((c) => c.id === order.farmorderCustomerId);
                      return orderCustomer?.company === CHEFS_FARM || !orderCustomer?.company
                        ? t("restaurant_name")
                        : t("customer_name");
                    })()}
                  >
                    {order.farmorderCustomerName}
                  </Descriptions.Item>
                  <Descriptions.Item label={t("exact_order_id")}>
                    {!!order.exactOrderNumber ? order.exactOrderNumber : "-"}
                  </Descriptions.Item>
                  {!!order.edifactOrderNumber && (
                    <Descriptions.Item label={t("edi_log_order_number")}>
                      <Link
                        to={`${APP_PREFIX_PATH}/edilog?edifactOrderNumber=${encodeURIComponent(
                          order.edifactOrderNumber,
                        )}`}
                      >
                        {order.edifactOrderNumber}
                      </Link>
                    </Descriptions.Item>
                  )}
                  {!!order.edifactOrderNumber &&
                    [
                      ["edi_order_received_at", lastEdiEventAt(ediHistory, "ORDERS", ["received", "parsed"])],
                      ["edi_aperak_sent_at", lastEdiEventAt(ediHistory, "APERAK", ["sent"])],
                      ["edi_desadv_sent_at", order.edifactDesadvSentAt],
                    ].map(([label, at]) => (
                      <Descriptions.Item key={label} label={t(label)}>
                        {at ? dayjs.unix(at).format("D MMM YYYY HH:mm") : "-"}
                      </Descriptions.Item>
                    ))}
                  {!!order.sooCoolId && (
                    <Descriptions.Item label={t("soo_cool_id")}>{order.sooCoolId}</Descriptions.Item>
                  )}
                  {!!order.sooCoolOrderKey && (
                    <Descriptions.Item label={t("soo_cool_order_key")}>{order.sooCoolOrderKey}</Descriptions.Item>
                  )}
                  {!!order.freshingBoxTrackingNumber && (
                    <Descriptions.Item label={t("freshing_box_tracking_number")}>
                      {order.freshingBoxTrackingNumber}
                    </Descriptions.Item>
                  )}
                  <Descriptions.Item label={t("order.orderer")}>
                    {!!order.farmorderUserFirstName
                      ? order.farmorderUserFirstName + " " + order.farmorderUserLastName
                      : order.farmorderUserId}
                  </Descriptions.Item>
                  {!!orderUser && <Descriptions.Item label={t("phone")}>{orderUser.userPhoneNumber}</Descriptions.Item>}
                  {!!order.userEmail && <Descriptions.Item label={t("email")}>{order.userEmail}</Descriptions.Item>}
                  <Descriptions.Item label={t("pickup_delivery_date")}>
                    {dayjs(order.farmorderDeliveryDate, "YYYY-MM-DD").format("ddd D MMM YYYY")}
                  </Descriptions.Item>
                  {!!order.deliveryBy && (
                    <Descriptions.Item label={t("delivery_by")}>{order.deliveryBy}</Descriptions.Item>
                  )}
                  {!!order.deliveryLabel && (
                    <Descriptions.Item label={t("delivery_label")}>{order.deliveryLabel}</Descriptions.Item>
                  )}
                  {!!order.deliveryTimeSlot && (
                    <Descriptions.Item label={t("delivery_time_slot")}>
                      {order.deliveryTimeSlot
                        ? `${order.deliveryTimeSlot.start} - ${order.deliveryTimeSlot.end}${
                            order.deliveryTimeSlot.deliverySurcharge > 0
                              ? ` (+${CURRENCY}${order.deliveryTimeSlot.deliverySurcharge})`
                              : ""
                          }`
                        : "-"}
                    </Descriptions.Item>
                  )}
                  {!!order.sooCoolStatus && (
                    <Descriptions.Item label={t("soocool_status")}>{order.sooCoolStatus}</Descriptions.Item>
                  )}
                  {!!order.trackAndTraceLink && (
                    <Descriptions.Item label={t("soocool_track_and_trace")}>
                      <a href={order.trackAndTraceLink} target={"_blank"}>
                        {order.trackAndTraceLink}
                      </a>
                    </Descriptions.Item>
                  )}
                  {!!order.deliveryNotes && (
                    <Descriptions.Item label={t("delivery_notes")}>{order.deliveryNotes}</Descriptions.Item>
                  )}
                  {!!order.shippingCosts && (
                    <Descriptions.Item label={t("shipping_costs")}>€ {order.shippingCost}</Descriptions.Item>
                  )}
                  {!!order.priceListId && (
                    <Descriptions.Item label={t("price_list")}>{order.priceListId}</Descriptions.Item>
                  )}
                  {!!order.customerDiscount && (
                    <Descriptions.Item label={t("customer_discount")}>{order.customerDiscount} %</Descriptions.Item>
                  )}
                  {!!order.farmorderComments && (
                    <Descriptions.Item
                      label={
                        <>
                          {t("order_notes")}
                          <Badge
                            status={order.orderCommentsProcessed ? "success" : "warning"}
                            style={{ marginLeft: 6 }}
                          />
                        </>
                      }
                    >
                      {!!order.farmorderComments ? order.farmorderComments : "-"}
                    </Descriptions.Item>
                  )}
                  <Descriptions.Item label={t("reference")}>
                    {isEditingReference ? (
                      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                        <Input
                          value={referenceValue}
                          onChange={(e) => setReferenceValue(e.target.value)}
                          onPressEnter={handleReferenceSave}
                          autoFocus
                          placeholder={t("form.enter_reference")}
                          maxLength={20}
                          style={{ flex: 1 }}
                        />
                        <Button type="primary" size="small" icon={<CheckOutlined />} onClick={handleReferenceSave} />
                        <Button size="small" icon={<CloseOutlined />} onClick={handleReferenceCancel} />
                      </div>
                    ) : (
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span>{order.reference || "-"}</span>
                        <Button
                          type="text"
                          size="small"
                          icon={<EditOutlined style={{ color: "#880e4f" }} />}
                          onClick={handleReferenceEdit}
                          style={{ padding: "0 4px" }}
                        />
                      </div>
                    )}
                  </Descriptions.Item>
                  {!!order.internalNotes && (
                    <Descriptions.Item label={t("internal_notes")}>
                      <Popover
                        content={
                          <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
                            <li>
                              <strong>{t("by")}:</strong>{" "}
                              {order.internalNotes.updatedBy || order.internalNotes.createdBy}
                            </li>
                            <li>
                              <strong>{t("date")}:</strong>{" "}
                              {dayjs
                                .unix(order.internalNotes.updatedAt || order.internalNotes.createdAt)
                                .format("DD-MM-YYYY, HH:mm")}
                            </li>
                          </ul>
                        }
                      >
                        {order.internalNotes.text}
                      </Popover>
                    </Descriptions.Item>
                  )}
                  <Descriptions.Item label={t("number_of_crates")}>{order.crates ?? 1}</Descriptions.Item>
                  {order.scannedCrates?.length > 0 && (
                    <Descriptions.Item label={t("crates")}>
                      {order.scannedCrates
                        .map((crate) => {
                          const sizeLabel = crate.size ? crate.size.toUpperCase() : "?";
                          return `${sizeLabel} x${crate.quantity}`;
                        })
                        .join(", ")}
                    </Descriptions.Item>
                  )}
                  {order.alertLog?.some((l) => l.status === "open") && (
                    <Descriptions.Item
                      label={
                        <span>
                          {t("alert_log")}
                          <Badge status="error" style={{ marginLeft: 4 }} />
                        </span>
                      }
                    >
                      {order.alertLog
                        ?.filter((l) => l.status === "open")
                        ?.map((log, index) => (
                          <div key={index}>
                            {dayjs.unix(log.timestamp).format("D MMM YYYY HH:mm")}: - {log.message}
                            <Button
                              type="link"
                              onClick={() => resolveAlertLogEntry(index)}
                              style={{ marginLeft: 6, padding: 0 }}
                            >
                              {t("resolve")}
                            </Button>
                          </div>
                        ))}
                    </Descriptions.Item>
                  )}
                </Descriptions>
                {!!orderUser && (
                  <ButtonsWrapper>
                    <Button onClick={() => copyToClipboard(orderUser.userPhoneNumber)} icon={<CopyOutlined />}>
                      {t("copy_phone_number")}
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => window.open(`tel:${orderUser.userPhoneNumber}`)}
                      icon={<PhoneOutlined />}
                    >
                      {t("call_user")}
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => window.open(generateWhatsAppLink(orderUser.userPhoneNumber))}
                      icon={<WhatsAppOutlined />}
                    >
                      {t("whatsapp_user")}
                    </Button>
                  </ButtonsWrapper>
                )}
                {!!order.userShoppingCart && (
                  <Descriptions
                    bordered
                    title={
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div className="flex-row mt-4">{t("products")}</div>
                        {hasUnsavedPriceChanges && profile?.userRole === roles.superAdmin && (
                          <div style={{ display: "flex", gap: "8px" }}>
                            <Button
                              size="small"
                              icon={<CloseOutlined />}
                              onClick={handleCancelPriceChanges}
                              disabled={isSavingPrices}
                            >
                              {t("cancel")}
                            </Button>
                            <Button
                              type="primary"
                              size="small"
                              icon={<CheckOutlined />}
                              onClick={handleSavePriceChanges}
                              loading={isSavingPrices}
                            >
                              {t("save")}
                            </Button>
                          </div>
                        )}
                      </div>
                    }
                    size="small"
                    column={1}
                  >
                    <div className="table-responsive">
                      <Table
                        showSorterTooltip={false}
                        columns={tableColumnsDetails}
                        dataSource={order.userShoppingCart.filter((item) => item.itemCount > 0)}
                        rowKey="userShoppingCart.productName"
                        pagination={false}
                        summary={(pageData) => {
                          const itemsAmount = pageData.length;
                          const displayOrder = recalculatedOrder || order;
                          const canEditPrices =
                            profile?.userRole === roles.superAdmin && !order?.packed && !order?.invoiceId;

                          if (order.totalAmount !== null && order.totalAmount !== undefined)
                            return (
                              !!order && (
                                <>
                                  <Table.Summary.Row>
                                    <Table.Summary.Cell>
                                      <Text strong>{t("subtotal")}</Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell />
                                    <Table.Summary.Cell />
                                    <Table.Summary.Cell>
                                      <Text strong>{CURRENCY + formatPrice(displayOrder.subTotalAmount)}</Text>
                                    </Table.Summary.Cell>
                                  </Table.Summary.Row>
                                  {!!order.discountCodeAmount && (
                                    <Table.Summary.Row>
                                      <Table.Summary.Cell>
                                        <Text strong>{t("discount")} (€)</Text>
                                      </Table.Summary.Cell>
                                      <Table.Summary.Cell />
                                      <Table.Summary.Cell />
                                      <Table.Summary.Cell>
                                        <Text strong>
                                          {CURRENCY}-{formatPrice(order.discountCodeAmount)}
                                        </Text>
                                      </Table.Summary.Cell>
                                    </Table.Summary.Row>
                                  )}
                                  {!!order.discountCodePercentage && (
                                    <Table.Summary.Row>
                                      <Table.Summary.Cell>
                                        <Text strong>{t("discount")} (%)</Text>
                                      </Table.Summary.Cell>
                                      <Table.Summary.Cell />
                                      <Table.Summary.Cell />
                                      <Table.Summary.Cell>
                                        <Text strong>
                                          {!!order.discountCodePercentage
                                            ? formatPrice(order.discountCodePercentage) + " %"
                                            : "0 %"}
                                        </Text>
                                      </Table.Summary.Cell>
                                    </Table.Summary.Row>
                                  )}
                                  <Table.Summary.Row>
                                    <Table.Summary.Cell>
                                      <Text strong>{t("shipping")}</Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell />
                                    <Table.Summary.Cell />
                                    <Table.Summary.Cell>
                                      {canEditPrices && order.shippingCost ? (
                                        editingShippingField ? (
                                          <InputNumber
                                            autoFocus
                                            value={
                                              editingShippingCost !== null
                                                ? editingShippingCost
                                                : parseFloat(order.shippingCost)
                                            }
                                            onChange={(value) => {
                                              if (value !== null) {
                                                setEditingShippingCost(value);
                                              }
                                            }}
                                            onBlur={() => setEditingShippingField(false)}
                                            onPressEnter={() => setEditingShippingField(false)}
                                            precision={2}
                                            min={0}
                                            step={0.01}
                                            style={{ width: "100px", fontWeight: 600 }}
                                            prefix="€"
                                          />
                                        ) : (
                                          <Text
                                            strong
                                            onClick={() => setEditingShippingField(true)}
                                            style={{
                                              cursor: "pointer",
                                              textDecoration: "underline",
                                              textDecorationStyle: "dashed",
                                            }}
                                          >
                                            {CURRENCY +
                                              formatPrice(
                                                editingShippingCost !== null ? editingShippingCost : order.shippingCost,
                                              )}
                                          </Text>
                                        )
                                      ) : (
                                        <Text strong>
                                          {!!order.shippingCost ? CURRENCY + formatPrice(order.shippingCost) : "-"}
                                        </Text>
                                      )}
                                    </Table.Summary.Cell>
                                  </Table.Summary.Row>
                                  {!!order.deliveryTimeCharge && (
                                    <Table.Summary.Row>
                                      <Table.Summary.Cell>
                                        <Text strong>{t("shipping_extra_costs")}</Text>
                                      </Table.Summary.Cell>
                                      <Table.Summary.Cell />
                                      <Table.Summary.Cell />
                                      <Table.Summary.Cell>
                                        {canEditPrices ? (
                                          editingDeliveryTimeField ? (
                                            <InputNumber
                                              autoFocus
                                              value={
                                                editingDeliveryTimeCharge !== null
                                                  ? editingDeliveryTimeCharge
                                                  : parseFloat(order.deliveryTimeCharge)
                                              }
                                              onChange={(value) => {
                                                if (value !== null) {
                                                  setEditingDeliveryTimeCharge(value);
                                                }
                                              }}
                                              onBlur={() => setEditingDeliveryTimeField(false)}
                                              onPressEnter={() => setEditingDeliveryTimeField(false)}
                                              precision={2}
                                              min={0}
                                              step={0.01}
                                              style={{ width: 120 }}
                                              prefix={CURRENCY}
                                            />
                                          ) : (
                                            <Text
                                              strong
                                              onClick={() => setEditingDeliveryTimeField(true)}
                                              style={{
                                                cursor: "pointer",
                                                textDecoration: "underline",
                                                textDecorationStyle: "dashed",
                                              }}
                                            >
                                              {CURRENCY +
                                                formatPrice(
                                                  editingDeliveryTimeCharge !== null
                                                    ? editingDeliveryTimeCharge
                                                    : order.deliveryTimeCharge,
                                                )}
                                            </Text>
                                          )
                                        ) : (
                                          <Text strong>
                                            {!!order.shippingCost
                                              ? CURRENCY + formatPrice(order.deliveryTimeCharge)
                                              : "-"}
                                          </Text>
                                        )}
                                      </Table.Summary.Cell>
                                    </Table.Summary.Row>
                                  )}
                                  <Table.Summary.Row>
                                    <Table.Summary.Cell>
                                      <Text strong={true}>{t("total")}</Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell>{itemsAmount}</Table.Summary.Cell>
                                    <Table.Summary.Cell />
                                    <Table.Summary.Cell>
                                      <Text strong={true}>{CURRENCY + formatPrice(displayOrder.totalAmount)}</Text>
                                    </Table.Summary.Cell>
                                  </Table.Summary.Row>
                                </>
                              )
                            );
                        }}
                      />
                    </div>
                  </Descriptions>
                )}
                {!order.userShoppingCart && (
                  <Descriptions
                    bordered
                    title={<div className="flex-row mt-4">{t("products")}</div>}
                    size="small"
                    column={1}
                  >
                    <Descriptions.Item style={{ fontWeight: "600" }} label={t("product_id")}>
                      <Text style={{ fontWeight: "600" }}>{t("quantity")}</Text>
                    </Descriptions.Item>

                    {Object.keys(order.farmorderItems).map((keyName) => (
                      <>
                        <Descriptions.Item label={keyName}>{order.farmorderItems[keyName]}</Descriptions.Item>
                      </>
                    ))}
                  </Descriptions>
                )}
              </Drawer>
            )}
          </Card>
          <ButtonsWrapper style={{ justifyContent: "start" }}>
            <Button onClick={() => handlePeriodChange(14)} type={maxDaysAgo === 14 ? "primary" : "default"}>
              {t("last_14_days")}
            </Button>
            <Button onClick={() => handlePeriodChange(30)} type={maxDaysAgo === 30 ? "primary" : "default"}>
              {t("last_30_days")}
            </Button>
            <Button onClick={() => handlePeriodChange(90)} type={maxDaysAgo === 90 ? "primary" : "default"}>
              {t("last_90_days")}
            </Button>
            <RangePicker onChange={handleCustomDateRange} placeholder={[t("start_date"), t("end_date")]} />
          </ButtonsWrapper>
          <Modal
            title={t("select_delivery_date")}
            open={dateSelectionModalVisible}
            onCancel={() => {
              setDateSelectionModalVisible(false);
              setSelectedDeliveryDate(null);
            }}
            footer={null}
          >
            <div style={{ textAlign: "center" }}>
              <p>{t("please_select_delivery_date")}</p>
              <DatePicker
                style={{ width: "100%" }}
                // disabledDate={(current) => current && current < dayjs().endOf("day")}
                onChange={handleDateSelection}
                value={selectedDeliveryDate}
              />
            </div>
          </Modal>
          <AddOrderModal
            visible={addOrderModalVisible}
            onClose={closeAddModal}
            customers={customers.filter((c) => companyFilter === "All" || c.company === companyFilter)}
            companyFilter={companyFilter}
            users={users}
            products={products.filter((p) => companyFilter === "All" || p.company === companyFilter)}
            selectedDeliveryDate={selectedDeliveryDate}
            order={order}
          />
          <EditOrderModal
            visible={editOrderModalVisible}
            onCancel={closeEditOrderModal}
            order={order}
            customers={customers.filter((c) => companyFilter === "All" || c.company === companyFilter)}
            users={users}
            products={products.filter((p) => companyFilter === "All" || p.company === companyFilter)}
            orders={orders}
            firestore={firestore}
            handleSendToSooCool={handleSendToSooCool}
          />
        </Col>
      </Row>
      <div style={{ display: "none" }}>
        {isPrinting && (
          <>{pickListOrders?.length > 0 && <SooCoolPickList ref={pickListRef} orders={pickListOrders} />}</>
        )}
      </div>
      <PreviewExcelOrdersModal
        visible={previewModalVisible}
        onSuccess={handlePreviewModalSuccess}
        onCancel={handlePreviewModalCancel}
        orders={previewOrders}
        skippedOrders={previewSkippedOrders}
        customers={customers}
      />
      <ImportEdifactOrderModal
        visible={importEdifactModalVisible}
        onCancel={() => setImportEdifactModalVisible(false)}
        onParsed={handleEdifactParsed}
      />
      <GenerateDesadvModal
        visible={!!generateDesadvOrder}
        order={generateDesadvOrder}
        onCancel={() => setGenerateDesadvOrder(null)}
        onGenerated={(desadv, summary) => {
          setGenerateDesadvOrder(null);
          viewDesadv({ ...generateDesadvOrder, edifactDesadvMessage: desadv, edifactDesadvSummary: summary });
        }}
      />
      <SendDesadvModal
        visible={!!sendDesadvOrder}
        order={sendDesadvOrder}
        onCancel={() => setSendDesadvOrder(null)}
        onSent={() => setSendDesadvOrder(null)}
      />
      <UnpackOrderModal
        open={unpackModalVisible}
        onCancel={() => {
          setUnpackModalVisible(false);
          setCancellingOrder(null);
        }}
        onConfirm={() => {
          setUnpackModalVisible(false);
          if (cancellingOrder) {
            executeCancelOrder(cancellingOrder);
            setCancellingOrder(null);
          }
        }}
        order={cancellingOrder}
        crateStocks={crateStocks}
        loading={false}
      />
    </>
  );
};

const UploadOverlayMessage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(2px);
  z-index: 2;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease-in-out;
`;

const StyledDragger = styled(Dragger)`
  .ant-upload-drag {
    cursor: default !important;
    border: none !important;
    border: ${(props) => (props.$isDragging ? "2px dashed #40a9ff" : "none")} !important;
    background: ${(props) => (props.$isDragging ? "#f0f8ff" : "transparent")} !important;
    transition: all 0.2s ease-in-out;

    .ant-upload {
      padding: 0 !important;
      cursor: default !important;
    }

    &:hover {
      border: ${(props) => (props.$isDragging ? "2px dashed #40a9ff" : "none")} !important;
      background: ${(props) => (props.$isDragging ? "#f0f8ff" : "transparent")} !important;
    }
  }
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 1rem;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 576px) {
    //flex-direction: column;
    align-items: flex-start;
  }
`;

const FilterPopoverContent = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const FilterLabel = styled.label`
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
`;

const FilterButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  padding-top: 4px;
  border-top: 1px solid #f0f0f0;
  margin-top: 4px;
`;

export default Orders;
